import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, ChevronDown, ChevronRight, Save } from "lucide-react";
import { api, extractErrorMessage } from "@/lib/api";

export const MissingIbanPanel = ({ refreshKey, onSaved }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [vals, setVals] = useState({});
  const [saving, setSaving] = useState("");

  const load = () => api.get("/personnel/missing-iban").then((r) => setRows(r.data.rows)).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  if (!rows.length) return null;

  const save = async (p) => {
    setSaving(p.id);
    try {
      await api.patch(`/personnel/${p.id}/iban`, { iban: vals[p.id] || "" });
      toast.success(`${p.ad_soyad} · IBAN kaydedildi`);
      load(); onSaved?.();
    } catch (e) { toast.error(extractErrorMessage(e, "Kaydedilemedi").replace(/^iban:\s*/i, "").replace(/Value error,\s*/i, "")); } finally { setSaving(""); }
  };

  return (
    <div className="mx-4 md:mx-5 mt-4 border border-amber-300 bg-amber-50 rounded-lg" data-testid="missing-iban-panel">
      <button type="button" onClick={() => setOpen(!open)} data-testid="missing-iban-toggle"
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm font-semibold text-amber-900">
        <AlertTriangle size={15} className="text-amber-600" />
        <span data-testid="missing-iban-count">{rows.length} aktif personelin IBAN'ı eksik</span>
        <span className="text-[11px] font-normal text-amber-700">· banka talimat dosyasına giremezler</span>
        <span className="ml-auto">{open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}</span>
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-1.5">
          {rows.map((p) => (
            <div key={p.id} className="flex items-center gap-2 flex-wrap bg-white border border-amber-200 rounded-md px-2 py-1.5" data-testid={`missing-iban-row-${p.sicil_no}`}>
              <div className="min-w-[180px] flex-1">
                <div className="text-sm font-semibold text-slate-900">{p.ad_soyad}</div>
                <div className="text-[11px] text-slate-500">{p.pozisyon} · {p.sicil_no}</div>
              </div>
              <input value={vals[p.id] || ""} onChange={(e) => setVals({ ...vals, [p.id]: e.target.value.toUpperCase() })}
                placeholder="TR00 0000 0000 0000 0000 0000 00" data-testid={`missing-iban-input-${p.sicil_no}`}
                className="w-80 px-2 py-1 border border-slate-300 rounded text-xs font-mono" />
              <button onClick={() => save(p)} disabled={saving === p.id || !vals[p.id]} data-testid={`missing-iban-save-${p.sicil_no}`}
                className="inline-flex items-center gap-1 px-2.5 py-1 bg-slate-900 text-white rounded text-xs font-semibold disabled:opacity-40">
                <Save size={12} /> Kaydet
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
